export default "__VITE_ASSET__BbRmKP_v__ 1250w";